import React, { useState } from 'react';
import { Field, ErrorMessage } from 'formik';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';

interface FormikInputProps {
	name: string;
	label?: string;
	type?: 'text' | 'password' | 'email' | 'number' | 'textarea';
	placeholder?: string;
	className?: string;
	rows?: number;
	disabled?: boolean;
}

export const FormikInput: React.FC<FormikInputProps> = ({
	name,
	label,
	type = 'text',
	placeholder,
	className = '',
	rows = 4,
	disabled = false,
}) => {
	const [showPassword, setShowPassword] = useState(false);
	const inputType = type === 'password' && showPassword ? 'text' : type;

	return (
		<FormGroup className="mb-3">
			{label && (
				<Label
					for={name}
					style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}
				>
					{label}
				</Label>
			)}

			<Field name={name}>
				{({ field, meta }: { field: any; meta: any }) => (
					<div className="position-relative">
						{type === 'textarea' ? (
							<Input
								{...field}
								id={name}
								type="textarea"
								rows={rows}
								placeholder={placeholder}
								invalid={meta.touched && !!meta.error}
								className={className}
								autoComplete="off"
								disabled={disabled}
							/>
						) : (
							<Input
								{...field}
								id={name}
								type={inputType}
								placeholder={placeholder}
								invalid={meta.touched && !!meta.error}
								className={className}
								autoComplete="off"
								disabled={disabled}
							/>
						)}

						{type === 'password' && (
							<button
								type="button"
								onClick={() => setShowPassword(!showPassword)}
								className="position-absolute end-0 top-50 translate-middle-y me-3 border-0 bg-transparent"
							>
								<i
									className={!showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'}
								></i>
							</button>
						)}

						<FormFeedback>
							<ErrorMessage name={name} />
						</FormFeedback>
					</div>
				)}
			</Field>
		</FormGroup>
	);
};
